// extracted by mini-css-extract-plugin
module.exports = {"pin-gk":"_6f25b66c20--pin-gk--34nMk"};